import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ddc097f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "view-container" }
const _hoisted_2 = { class: "view-container-content" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "display-style-box" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-style-box" }, "图片:", -1))
const _hoisted_6 = { class: "menu-icon-content-box" }
const _hoisted_7 = { class: "menu-item-box" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "默认", -1))
const _hoisted_9 = { class: "menu-item-box" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "展开", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-image-remake" }, " 图片尺寸建议：大于50*50像素，支持PNG格式 ", -1))
const _hoisted_12 = { class: "sort-menu-list-box" }
const _hoisted_13 = { class: "card-head-box" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "display-style-box" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-style-box" }, "标题:", -1))
const _hoisted_17 = { class: "display-style-box" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "left-style-box" }, "图片:", -1))
const _hoisted_19 = { class: "menu-icon-content-box" }
const _hoisted_20 = { class: "menu-item-box" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "默认", -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "menu-image-remake" }, " 图片要求：使用 50x50 像素的圆形 png 图片 ", -1))
const _hoisted_23 = { class: "edit-link-box" }
const _hoisted_24 = { class: "edit-left-box" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "edit-link-left-box" }, "页面:", -1))
const _hoisted_26 = {
  key: 1,
  class: "list-category-right"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_tabbar = _resolveComponent("ui-tabbar")!
  const _component_ui_choose_icon = _resolveComponent("ui-choose-icon")!
  const _component_ui_icon_zhizhi = _resolveComponent("ui-icon-zhizhi")!
  const _component_Close = _resolveComponent("Close")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_ui_select_link = _resolveComponent("ui-select-link")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_draggable = _resolveComponent("draggable")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_layout2 = _resolveComponent("ui-layout2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_ui_tabbar, {
      modelValue: _ctx.valueType,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.valueType) = $event)),
      list: _ctx.list
    }, null, 8, ["modelValue", "list"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.valueType == 'first')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_ui_choose_icon, {
                      modelValue: _ctx.source.icon1,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.source.icon1) = $event)),
                      showClose: false,
                      tips: "更换图片"
                    }, null, 8, ["modelValue"]),
                    _hoisted_8
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_ui_choose_icon, {
                      modelValue: _ctx.source.icon2,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.source.icon2) = $event)),
                      tips: "更换图片",
                      showClose: false
                    }, null, 8, ["modelValue"]),
                    _hoisted_10
                  ])
                ]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createVNode(_component_draggable, {
                modelValue: _ctx.source.list,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.source.list) = $event)),
                handle: ".card-head-box"
              }, {
                item: _withCtx(({ element, index }) => [
                  (_openBlock(), _createBlock(_component_el_card, {
                    class: "menu-card-box",
                    key: index
                  }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_ui_icon_zhizhi, { modelValue: "iconsort" })
                      ])
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "close-right-button",
                        onClick: _withModifiers(($event: any) => (_ctx.removeIndex(index)), ["stop"])
                      }, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Close)
                          ]),
                          _: 1
                        })
                      ], 8, _hoisted_14),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createVNode(_component_el_input, {
                          placeholder: "可留空",
                          modelValue: element.name,
                          "onUpdate:modelValue": ($event: any) => ((element.name) = $event)
                        }, null, 8, ["modelValue", "onUpdate:modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createVNode(_component_ui_choose_icon, {
                                modelValue: element.icon,
                                "onUpdate:modelValue": ($event: any) => ((element.icon) = $event),
                                showClose: false,
                                tips: "更换图片"
                              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                              _hoisted_21
                            ])
                          ]),
                          _hoisted_22
                        ])
                      ]),
                      _createVNode(_component_el_divider),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _hoisted_25,
                          _createVNode(_component_ui_select_link, {
                            type: "menu",
                            mode: "3",
                            modelValue: element.link,
                            "onUpdate:modelValue": ($event: any) => ((element.link) = $event)
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]),
                        _createElementVNode("div", null, [
                          _createVNode(_component_el_checkbox, {
                            onInput: ($event: any) => (_ctx.changeCheck(element)),
                            modelValue: element.fixed == 1,
                            "true-label": 1,
                            "false-label": 0
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("独立界面")
                            ]),
                            _: 2
                          }, 1032, ["onInput", "modelValue"])
                        ])
                      ])
                    ]),
                    _: 2
                  }, 1024))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_button, {
                class: "button-width-box",
                onClick: _ctx.addMenu,
                type: "primary"
              }, {
                default: _withCtx(() => [
                  _createTextVNode("+ 添加导航")
                ]),
                _: 1
              }, 8, ["onClick"])
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_26, [
            (_ctx.source.show)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createVNode(_component_ui_layout2, { title: "店铺主页" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.source.show.home,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.source.show.home) = $event)),
                        "true-label": 1,
                        "false-label": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ui_layout2, { title: "商品详情" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.source.show.goods_category,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.source.show.goods_category) = $event)),
                        "true-label": 1,
                        "false-label": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ui_layout2, { title: "商品分组" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_checkbox, {
                        modelValue: _ctx.source.show.goods_detail,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.source.show.goods_detail) = $event)),
                        "true-label": 1,
                        "false-label": 0
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true)
          ]))
    ])
  ]))
}